const URL_RE = /(https?:\/\/[^\s]+)/g;

const pretty = (url) => {
  try {
    const u = new URL(url);
    const tail = u.pathname.length > 1 ? u.pathname : "";
    const shown = `${u.hostname.replace(/^www\./, "")}${tail}`;
    return shown.length > 42 ? `${shown.slice(0, 42)}…` : shown;
  } catch {
    return url;
  }
};

// Message text with any links made tappable, shown as the site rather than a wall of characters.
export const RichText = ({ text }) =>
  String(text || "").split(URL_RE).map((part, i) =>
    i % 2 === 1 ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noreferrer"
        title={part}
        data-testid={`message-link-${i}`}
        onClick={(e) => e.stopPropagation()}
        className="break-all underline decoration-dotted underline-offset-2 hover:opacity-80"
      >
        {pretty(part)}
      </a>
    ) : (
      part
    ));
